import Vue from 'vue'
import VueRouter from 'vue-router'

import { mapActions } from 'vuex'

import Home from '../views/Home.vue'
import Activity2F from '@/router/activity_2f_otolith'
import Activity4B from '@/router/activity_4b_sst'

Vue.use(VueRouter)

const baseRoutes = [
    {
        path: '/',
        name: 'home',
        component: () => import(/* webpackChunkName: "meta" */ '../views/Home.vue')
    },
    {
        path: '/about/',
        name: 'about',
        pathToRegexpOptions: { strict: true },
        component: () => import(/* webpackChunkName: "meta" */ '../views/About.vue')
    }
]

const routes = [...baseRoutes, ...Activity2F, ...Activity4B]


const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
